import { Components, Theme } from '@mui/material/styles';

export default function MuiMenuItem(theme: Theme): Components['MuiMenuItem'] {
  return {
    styleOverrides: {
      root: {
        '&:hover': {
          backgroundColor: theme.palette.sandShade1.main,
        },
        '&.Mui-focusVisible': {
          backgroundColor: theme.palette.sandShade1.main,
        },
      },
    },
  };
}
